import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { Feature } from 'stores/FeatureStore';
import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { DefaultCopyToClipboard } from 'components/CopyToClipboard';
import { SimpleInlineHelp } from 'components/InlineHelp';

export interface UserInputDictionary
{
  [key: string]: string,
}

interface Props
{
  userInput: UserInputDictionary,
  saveUserInput: (input: UserInputDictionary) => void,
  feature: Feature,
}

export const EditForm: React.FC<Props> = ({userInput, saveUserInput, feature}: Props) =>
{
  const [name, setName] = useState(userInput['name'] || feature.name || '');
  const [description, setDescription] = useState(userInput['description'] || feature.description || '');
  const history = useHistory();

  const { uiStore, featureStore } = useStore();
  const saveFeatureHandler = async () =>
  {
    saveUserInput({"name": name, "description": description});
    const featureToken = featureStore.feature?.token || '';
    await featureStore.updateAsync(featureToken, name, description);
    if (!featureStore.isError)
    {
      history.push(paths.buildFeatureViewPath(featureToken));
    }
  };
  const cancelHandler = () =>
  {
    featureStore.clearError();
    history.goBack();
  }
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.feature.token.label}:<SimpleInlineHelp>{uiStore.labels.help.features.token.about}</SimpleInlineHelp>
          <DefaultCopyToClipboard text={feature.token} />
          <input type="text" value={feature.token} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.feature.name.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.feature.name.placeholder} value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label>
          {uiStore.labels.common.forms.feature.description.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.feature.description.placeholder} value={description} onChange={e => setDescription(e.target.value)} />
        </label>

        <div className="info">
          <p>{uiStore.labels.common.forms.feature.createdBy.apply({by: feature.created_by, at: new Date(Date.parse(feature.created_at || '')).toLocaleString(),})}</p>
          <p>{uiStore.labels.common.forms.feature.updatedBy.apply({by: feature.updated_by, at: new Date(Date.parse(feature.updated_at || '')).toLocaleString(),})}</p>
        </div>
      </div>

      <div className="actions">
        <button onClick={saveFeatureHandler}>{uiStore.labels.common.forms.save}</button>
        <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
      </div>
    </>
  );
};